import { render, staticRenderFns } from "./BrandModel.vue?vue&type=template&id=ae621c8e"
import script from "./BrandModel.vue?vue&type=script&lang=js"
export * from "./BrandModel.vue?vue&type=script&lang=js"
import style0 from "./BrandModel.vue?vue&type=style&index=0&id=ae621c8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports